export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData) && !headers.has("content-type")) headers.set("content-type", "application/json");
  const response = await fetch(path, { credentials: "same-origin", ...init, headers });
  if (response.status === 204) return undefined as T;
  const contentType = response.headers.get("content-type") ?? "";
  if (!contentType.includes("json")) {
    if (!response.ok) throw new ApiError(response.status, "The request could not be completed.");
    return undefined as T;
  }
  const data = (await response.json()) as { error?: { message?: string } };
  if (!response.ok) throw new ApiError(response.status, data.error?.message || "The request could not be completed.");
  return data as T;
}

export function eurosToMinor(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) return null;
  const [major, cents = ""] = trimmed.split(".");
  return Number(major) * 100 + Number(cents.padEnd(2, "0"));
}

export function minorToEuros(value: number | null | undefined): string {
  if (value == null) return "";
  return (value / 100).toFixed(2);
}
